export enum TOKEN_TYPE {
    ACCESS = 'accessToken',
    ID = 'idToken',
    REFRESH = 'refreshToken',
    ORG_ID = 'orgId',
    ORG_LIST = 'orgList',
    UI_ANALYTICS = 'uiAnalytics'
}

export interface TokensInterface {
    accessToken: string;
    idToken: string;
    refreshToken: string;
    orgId: string;
    orgList: string;
    uiAnalytics: boolean;
}
